const autoNgTemplateLoaderTemplate1 = require('./porAccessControlForm.html');

angular.module('shbdeployer.app').component('porAccessControlForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'porAccessControlFormController',
  bindings: {
    // Объект, в который записываются данные формы (модель — porAccessControlFormModel.js).
    formData: '=',
    // Необязательно. Существующий объект управления доступом, задающий значения по умолчанию.
    resourceControl: '<',
    hideTitle: '<',
  },
});
